import React from "react";
import Default from "../components/dashboard/defaultCompo/default";

// Masters
import Groups from "../pages/masters/groups"
import Size from "../pages/masters/size";
import Category from "../pages/masters/category";
import Brand from "../pages/masters/brand";
import Material from "../pages/masters/material";
import Color from "../pages/masters/color";

// Products
import Products from "../pages/product/addProduct";
import AllProducts from "../pages/product/AllProducts";

// users
import UserLists from "../pages/user/userLists";

//Home banner
import AllBanners from "../pages/home-banner/AllBanners";
import AddHomeBanner from "../pages/home-banner/AddHomeBanner";

//notifiction
import AllNotification from "../pages/notification/AllNotification";
import AddNotification from "../pages/notification/AddNotification";

//orders
import AllOrders from "../pages/orders/AllOrders";

//featured types
import AllFeatureTypes from "../pages/feature-types/AllFeatureTypes";
import AddFeatureTypes from "../pages/feature-types/AddFeatureTypes";

//home section
import AllHomeSection from "../pages/home-section/AllHomeSectionList";
import AddHomeSection from "../pages/home-section/AddHomeSection";

//Sales Report
import SalesReport from "../pages/reports/SalesReport";
import OrderDetails from "../pages/reports/OrderDetails";
import SalesProductCount from "../pages/reports/SalesProductCount";

//Purchase
import PurchaseList from "../pages/purchases/PurchaseList";
import PurchaseAdd from "../pages/purchases/PurchaseAdd";
import PurchaseDetails from "../pages/purchases/PurchaseDetails";
import StockReport from "../pages/reports/StockReports";
import HeaderLogo from "../pages/HeaderLogo";
import OfferSectionHeadline from "../pages/OfferSectionHeadline/OfferSectionHeadline";
import ManageHomeSections from "../pages/settings/ManageHomeSections";
import ManageFeatureCards from "../pages/ManageFeatureCards";
import OrderDetailsPage from "../pages/orders/OrderDetailsPage";

export const routes = [
  { path: `/dashboard`, Component: <Default /> },

  //orders
  { path: `/pages/orders`, Component: <AllOrders /> },
  { path: `/pages/order-details`, Component: <OrderDetailsPage /> },

  //purchase
  { path: `/pages/purchase-add`, Component: <PurchaseAdd /> },
  { path: `/pages/purchase-list`, Component: <PurchaseList /> },
  { path: `/pages/purchase-details/:id`, Component: <PurchaseDetails /> },

  // {/* Masters */}
  { path: `/pages/groups`, Component: <Groups /> },
  { path: `/pages/size`, Component: <Size /> },
  { path: `/pages/category`, Component: <Category /> },
  { path: `/pages/brand`, Component: <Brand /> },
  { path: `/pages/material`, Component: <Material /> },
  { path: `/pages/color`, Component: <Color /> },
  { path: `/pages/offer-card-section-headline`, Component: <OfferSectionHeadline /> },

  // {/* Products */}
  { path: `/pages/products/add`, Component: <Products /> },
  { path: `/pages/products/edit/:id`, Component: <Products /> },
  { path: `/pages/product-list`, Component: <AllProducts /> },

  // users
  { path: `/pages/user/users-list`, Component: <UserLists /> },

  //Home Bannerss
  { path: `/pages/home-banners/banner-list`, Component: <AllBanners /> },
  { path: `/pages/home-banners/add`, Component: <AddHomeBanner /> },
  { path: `/pages/home-banners/edit/:id`, Component: <AddHomeBanner /> },

  //Manage Feature Cards
  { path: `/pages/manage-feature-card`, Component: <ManageFeatureCards /> },


  //Notification
  { path: `/pages/notification/notification-list`, Component: <AllNotification /> },
  { path: `/pages/notification/create`, Component: <AddNotification /> },
  { path: `/pages/notification/edit/:id`, Component: <AddNotification /> },

  //feature types
  { path: `/pages/feature-type/feature-type-list`, Component: <AllFeatureTypes /> },
  { path: `/pages/feature-type/add`, Component: <AddFeatureTypes /> },
  { path: `/pages/feature-type/edit/:id`, Component: <AddFeatureTypes /> },

  //Home Section
  { path: `/pages/home-section/home-section-list`, Component: <AllHomeSection /> },
  { path: `/pages/home-section/add`, Component: <AddHomeSection /> },
  { path: `/pages/home-section/edit/:id`, Component: <AddHomeSection /> },
  { path: `/pages/logo-management`, Component: <HeaderLogo /> },

  //Reports
  { path: `/pages/sales-report`, Component: <SalesReport /> },
  { path: `/pages/sales-report/order-details/:orderId`, Component: <OrderDetails /> },
  { path: `/pages/sales-count-report`, Component: <SalesProductCount /> },
  { path: `/pages/stock-report`, Component: <StockReport /> },

  //Settings
  { path: `/pages/manage-home-section`, Component: <ManageHomeSections /> },
  { path: `/pages/manage-currency`, Component: <ManageHomeSections /> },


];
